const toTransparent = (color, alpha = 0.2) => {
  if (color.startsWith("#")) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  if (color.startsWith("rgb")) {
    return color.replace(/^rgb(a?)\(([^)]+)\)/, (_, a, values) => {
      const rgbValues = values
        .split(",")
        .slice(0, 3)
        .map((v) => v.trim());
      return `rgba(${rgbValues.join(", ")}, ${alpha})`;
    });
  }

  return color;
};

export default { toTransparent };
